<template>
  <div class="login-page">
    <div class="login-container">
      <div class="logo-container">
        <img :src="require('@/assets/img/logo.svg')" alt="Logo" class="logo-img">
      </div>
      <div class="card login-card">
        <div class="card-header login-header">
          <h2 class="mb-0">
            <i class="fa fa-sign-in-alt me-2 mr-3 ml-3"></i>
            Авторизація
          </h2>
        </div>
        <div class="card-body">
          <div v-if="error" class="alert alert-danger alert-dismissible fade show" role="alert">
            <i class="fa fa-exclamation-circle me-2 mr-2"></i> {{ error }}
            <button type="button" class="btn-close" @click="error = null" aria-label="Close"></button>
          </div>

          <form @submit.prevent="login">
            <div class="mb-3">
              <label for="email" class="form-label">Пошта/Телефон</label>
              <input type="text" v-model="auth.email" name="email" id="email" class="form-control"
                placeholder="Введіть пошту або телефон" autocomplete="username" required>
            </div>
            <div class="mb-4">
              <label for="password" class="form-label">Пароль</label>
              <input type="password" v-model="auth.password" name="password" id="password" class="form-control"
                placeholder="Введіть пароль" autocomplete="current-password" required>
            </div>
            <button type="submit" :disabled="processing" class="btn btn-primary w-100">
              <i v-if="processing" class="fa fa-spinner fa-spin me-1"></i>
              <i v-else class="fa fa-sign-in-alt me-1"></i>
              {{ processing ? "Зачекайте..." : "Увійти" }}
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: "login",
  data() {
    return {
      auth: {
        email: "",
        password: ""
      },
      processing: false,
      error: null
    }
  },
  methods: {
    ...mapActions({
      signIn: 'auth/login'
    }),
    async login() {
      this.processing = true
      this.error = null

      await axios.post('/login', this.auth).then(({ data }) => {
        data.user['defaultStock'] = data.defaultStock
        this.signIn(data)
      }).catch(({ response: { data } }) => {
        this.error = data.message || 'Помилка авторизації. Перевірте введені дані.'
      }).finally(() => {
        this.processing = false
      })
    },
  }
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.login-container {
  width: 100%;
  max-width: 450px;
}

.logo-container {
  text-align: center;
  margin-bottom: 32px;
}

.logo-img {
  max-width: 200px;
  height: auto;
  display: inline-block;
}

.login-card {
  border: none;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.login-header {
  background: linear-gradient(135deg, #2c5aa0 0%, #1e4a8a 100%);
  color: white;
  padding: 24px;
  border-bottom: none;
}

.login-header h2 {
  font-size: 1.4rem;
  font-weight: 600;
  color: white;
  display: flex;
  align-items: center;
}

.login-card .card-body {
  padding: 32px;
}

.alert {
  border-radius: 8px;
  border: none;
  padding: 14px 16px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.alert-danger {
  background-color: #fee2e2;
  color: #991b1b;
  border-left: 4px solid #dc2626;
}

.alert i {
  font-size: 1.1rem;
}

.alert strong {
  margin-right: 4px;
}

.btn-close {
  padding: 0;
  background: transparent;
  border: none;
  font-size: 1.2rem;
  line-height: 1;
  color: #991b1b;
  opacity: 0.5;
  cursor: pointer;
  margin-left: auto;
  transition: opacity 0.2s ease;
}

.btn-close:hover {
  opacity: 1;
}

.btn-close::before {
  content: "×";
  font-size: 1.5rem;
}

.form-label {
  font-weight: 500;
  color: #2c3e50;
  margin-bottom: 8px;
}

.form-control {
  padding: 12px 16px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.form-control:focus {
  border-color: #2c5aa0;
  box-shadow: 0 0 0 0.2rem rgba(44, 90, 160, 0.15);
}

.btn-primary {
  background-color: #2c5aa0;
  border-color: #2c5aa0;
  padding: 12px 16px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.btn-primary:hover:not(:disabled) {
  background-color: #1e4a8a;
  border-color: #1e4a8a;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(44, 90, 160, 0.3);
}

.btn-primary:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 2px 6px rgba(44, 90, 160, 0.2);
}

.btn-primary:disabled {
  background-color: #6c757d;
  border-color: #6c757d;
  opacity: 0.65;
  cursor: not-allowed;
}

/* Responsive */
@media (max-width: 576px) {
  .login-page {
    padding: 15px;
  }

  .logo-container {
    margin-bottom: 24px;
    padding: 20px;
  }

  .logo-img {
    max-width: 160px;
  }

  .login-header {
    padding: 20px;
  }

  .login-header h2 {
    font-size: 1.25rem;
  }

  .login-card .card-body {
    padding: 24px;
  }

  .form-control {
    padding: 10px 14px;
  }

  .btn-primary {
    padding: 10px 14px;
  }
}
</style>
